import vuetify from './plugins/vuetify';
import ds from './plugins/designSystem';
import {imageService, postMessageService} from './modules/common/services'
import {urlUtil, constants} from '@/modules/common/utils';

import '@/assets/scss/main.scss';

import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import "./plugins/index";
import "@/modules/common/filters";
import "@/modules/common/directives";
import "@/../styles/variables.scss";
import 'requestidlecallback-polyfill';
import "@/modules/common/constants/momentLocalization";

const initFunc = async (hostBrand, app_config) => {
  window.hostBrand = hostBrand;
  window.app_config = app_config;
  await store.dispatch({type: 'brandModule/initBrand', brand: window.hostBrand})

  imageService.setFrontageImages(window.app_config.assets)
  constants.init(mobileApp, window.hostBrand, window.app_config)
  // await initI18N(urlUtil.getParameterByName("lang"));
  new Vue({
    router,
    vuetify: ds,
    store,
    // i18n: getI18n(),
    render: h => h(App)
  }).$mount("#app");
};

Vue.prototype.$log = Vue.prototype.$log || console.log;
Vue.config.productionTip = false;

const mobileApp = urlUtil.getParameterByName("MobileApp") === "1";
const mobileView = urlUtil.getParameterByName("MobileView") === "1";
const isCordovaApp = mobileApp && !window.navigator.userAgent.match('vcitapp');
const paneView = urlUtil.getParameterByName("PaneView") === "1";
const staffUid = urlUtil.getParameterByName("staffUid");
if (staffUid) {
  store.dispatch("auth/init", staffUid);
}
store.commit("setIsAndroid", ((navigator.userAgent.toLowerCase()).indexOf("android") > -1));
store.commit("setIsiPhone", !!window.navigator.userAgent.match('iPhone'));
store.commit("setIsiPad", !!window.navigator.userAgent.match(/Mac/) && !!window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 2);
store.commit("setIsTouchScreen", window.matchMedia("(pointer: coarse)").matches);
store.commit("setChromeIos", !!window.navigator.userAgent.match('CriOS'));
store.commit("setMobile", mobileView);
store.commit("setMobileApp", mobileApp);
store.commit("setCordovaApp", isCordovaApp);
store.commit("setPane", paneView);
store.commit("setLang", urlUtil.getParameterByName("lang"));
if (urlUtil.getParameterByName("lang") === 'he'){
  store.commit("setDirection",'rtl');
}

if (mobileApp && isCordovaApp) {
  window.addEventListener("message", function(e) {
    if (typeof e.data !== 'string' || !e.data.includes('mobile-app-message')) return

    const data = JSON.parse(e.data)
    initFunc(data.host_brand, data.app_config);
  });
  window.addEventListener("message", function(e) {
    if (typeof e.data !== 'string') return

    const data = JSON.parse(e.data)
    if(data.event_name === "keyboardDidShow") {
      document.activeElement.scrollIntoViewIfNeeded({behavior: "smooth", block: "end", inline: "nearest"});
    }
  })
  postMessageService.post('vue_ready');
} else {
  initFunc(window.parent.hostBrand, window.parent.app_config);
}
